module.exports = __webpack_public_path__ + "img/jiangsu.6decd4b.png";